module.exports = __webpack_public_path__ + "img/borderRectangleWhite.2d1051bc.svg";